// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type AiProposalFailureBanner_AiProposalFragment = { __typename?: 'PlanPackageAiProposal', id: string, failureReason?: string | null | undefined, workflow?: { __typename?: 'PlanPackageAiProposalWorkflowDetail', code: Types.PlanPackageAiProposalWorkflow } | null | undefined };

export const AiProposalFailureBanner_AiProposalFragmentDoc = gql`
    fragment AiProposalFailureBanner_AiProposal on PlanPackageAiProposal {
  id
  workflow {
    code
  }
  failureReason
}
    `;